'use client'

import { ThemeProvider } from '@quark/theme'
import React, { useEffect, useState } from 'react'
import UserServiceApi from '@services/userService'
import BusinessModals from '@components/BusinessModal/businessModals'
import { useHybridIsMobile } from '@utils/fallbackIsMobile'
import { Locale } from '@enums/strapiTypesAndOperators'
import LocaleHeaderTooltip from '@components/Product/ProductNav/LocaleHeaderTooltip'
import { useUserContext } from '@context/UserContext/UserContenxt'
import DesktopHeader from './Desktop'
import HeaderMobile from './Mobile'

const HomeHeader = React.memo((props: any) => {
  const [userData, setUserData] = useState<any>(false)
  const isMobile = useHybridIsMobile(props.isMobile)
  const [formSnippet, setFormSnippet] = useState<string>('')
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const { isLoggedIn } = useUserContext()

  const handleSetFormSnippet = (snippet: string) => {
    setFormSnippet(snippet)
    setIsModalOpen(true)
  }

  useEffect(() => {
    if (isLoggedIn) {
      UserServiceApi.getUserDetails()
        .then(userDetail => {
          const data = {
            email: userDetail.email,
            name: userDetail.name,
            phone: userDetail.phone,
            gender: userDetail.gender,
            avatar: userDetail.name.charAt(0),
          }
          setUserData(data)
        })
        .catch(err => {
          console.log('CATCH USER DETAILS ERROR : ', err)
        })
    }
  }, [isLoggedIn])
  return (
    <ThemeProvider brand="DEFAULT" theme="LIGHT">
      {!isMobile ? (
        <DesktopHeader
          isLoggedIn={isLoggedIn && userData}
          userData={userData}
          content={props.data}
          animate={props.animate}
          ackoLogo={props.ackoLogo}
          isSemPage={props.isSemPage}
          setFormSnippet={handleSetFormSnippet}
          showLoginButton={props?.showLoginButton}
          selectedLanguage={props.selectedLanguage || Locale.English}
          availableLanguages={props.availableLanguages || [Locale.English]}
          defaultLink={props?.defaultLink}
        />
      ) : (
        <HeaderMobile
          isLoggedIn={isLoggedIn && userData}
          userData={userData}
          content={props.data}
          animate={props.animate}
          ackoLogo={props.ackoLogo}
          isSemPage={props.isSemPage}
          setFormSnippet={handleSetFormSnippet}
          showLoginButton={props?.showLoginButton}
          showFileAClaimButton={props?.showFileAClaimButton}
          selectedLanguage={props.selectedLanguage || Locale.English}
          availableLanguages={props.availableLanguages || [Locale.English]}
          defaultLink={props?.defaultLink}
        />
      )}
      {props.tooltipLang && props.tooltipLang === props.selectedLanguage && (
        <LocaleHeaderTooltip lang={props.tooltipLang} />
      )}
      <BusinessModals isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} content={formSnippet} />
    </ThemeProvider>
  )
})

export default HomeHeader
